export class AppPermissions {
  // User
  public static readonly inventoryEditPrice: string = 'inventory-edit-price';
  public static readonly inventoryEditBroadcast: string =
    'inventory-edit-broadcast';
  public static readonly inventoryEditTags: string = 'inventory-edit-tags';
  public static readonly inventoryMassEdit: string = 'inventory-mass-edit';
  public static readonly inventoryEdit: string = 'inventory-edit';
  public static readonly inventoryAdd: string = 'inventory-add';
  public static readonly inventoryHold: string = 'inventory-hold';
  public static readonly inventoryMerge: string = 'inventory-merge';
  public static readonly inventorySplit: string = 'inventory-split';
  public static readonly paymentsAccess: string = 'payments-access';
  public static readonly poAccountsAccess: string =
    'purchasing-accounts-access';
  public static readonly optimalInsightsAccess: string =
    'optimal-insights-access';
  public static readonly workQueueManager: string = 'work-queue-manager';

  // Manager
  public static readonly accountsAccess: string = 'accounts-access';
  public static readonly accountsActions: string = 'accounts-actions';

  // Admin
  public static readonly adminAccess: string = 'admin-access';
}
